import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class Timeline extends Component {
	
	constructor(props) {
		super(props);		
	}

	render() {		
		return (
		<div className="Timeline">
			<div className="Event">
				<div className="EventInner">
					<div className="EventPeriod">Jour 1</div>
					<div className="EventDescription">Arrivée des explorateurs Agonien sur l'île, construction de Port l'Espérance, début de l'exploration des premières ruines.</div>
				</div>
				<div className="Marker" />
			</div>
			<div className="Event">
				<div className="EventInner">
					<div className="EventPeriod">Jour 7</div>
					<div className="EventDescription NewMoon"><FontAwesomeIcon icon="circle"/> Nouvelle Lune</div>
				</div>
				<div className="Marker" />
			</div>
			<div className="Event">
				<div className="EventInner">
					<div className="EventPeriod">Jour 14</div>
					<div className="EventDescription">Le Roi Noir brûle en partie l'auberge de Nobu; travail de reconstruction et d'aggrandissement!</div>
				</div>				
				<div className="Marker" />
			</div>
			<div className="Event">
				<div className="EventInner">
					<div className="EventPeriod">Jour 19</div>
					<div className="EventDescription">Découverte de nouvelles ruines dans la jungle, construction de l'avant-poste</div>
				</div>				
				<div className="Marker" />
			</div>
			<div className="Event">
				<div className="EventInner">
					<div className="EventPeriod">Jour 21</div>
					<div className="EventDescription FullMoon"><FontAwesomeIcon icon="circle"/> Pleine Lune</div>
				</div>				
				<div className="Marker" />
			</div>
			<div className="Event">
				<div className="EventInner">
					<div className="EventPeriod">Jour 26</div>
					<div className="EventDescription">Découverte de la tour d'émeraude, un deuxième port est établi pour faire navette et ramener les découvertes de la tour d'émeraude à Port l'Espérance.</div>
				</div>				
				<div className="Marker" />
			</div>
			<div className="Event">
				<div className="EventInner">
					<div className="EventPeriod">Jour 32</div>
					<div className="EventDescription">Découverte de ruines englouties dans les eaux autours de Port l'Espérance.</div>
				</div>				
				<div className="Marker" />
			</div>
			<div className="Event">
				<div className="EventInner">
					<div className="EventPeriod">Jour 34</div>
					<div className="EventDescription">Découverte du labyrinthe de la méduse dans un tableau qui fait office de portail interdimensionnel.</div>
				</div>				
				<div className="Marker" />
			</div>
			<div className="Event">
				<div className="EventInner">
					<div className="EventPeriod">Jour 35</div>
					<div className="EventDescription NewMoon"><FontAwesomeIcon icon="circle"/> Nouvelle Lune.</div>
				</div>			
				<div className="Marker" />				
			</div>
			<div className="Event">
				<div className="EventInner">
					<div className="EventPeriod">Jour 36</div>
					<div className="EventDescription">Déstruction d'une partie du corail autour de Port l'Espérance.</div>
				</div>		
				<div className="Marker" />
			</div>
			<div className="Event">
				<div className="EventInner">
					<div className="EventPeriod">Jour 38</div>
					<div className="EventDescription">Le géant habitant le château de corail lance une malédiction sur Port l'Espérance et défie les aventuriers à venir le voir.</div>
				</div>				
				<div className="Marker" />
			</div>
			<div className="Event">
				<div className="EventInner">
					<div className="EventPeriod">Jour 42</div>
					<div className="EventDescription">Arrivée des Balloniers, exploration de nouvelles ruines découvertes au centre de l'île.</div>
				</div>				
				<div className="Marker" />
			</div>
			<div className="Event">
				<div className="EventInner">
					<div className="EventPeriod">Jour 44</div>
					<div className="EventDescription">Les Balloniers guettent une expédition du Sultanat de Zhaibar, découverte de Tumuli au sud-ouest de l'île.</div>
				</div>	
				<div className="Marker" />				
			</div>
			<div className="Event">
				<div className="EventInner">
					<div className="EventPeriod">Jour 49</div>
					<div className="EventDescription FullMoon"><FontAwesomeIcon icon="circle"/> Pleine Lune</div>
				</div>
				<div className="Marker" />
			</div>
			<div className="Event">
				<div className="EventInner">
					<div className="EventPeriod">Jour 53</div>
					<div className="EventDescription">Découverte d'une tombe d'un homme serpent, pillée dans la journée.</div>
				</div>	
				<div className="Marker" />
			</div>
			<div className="Event">
				<div className="EventInner">
					<div className="EventPeriod">Jour 54</div>
					<div className="EventDescription">Elvis dit "Shatter Sauvage" est mort, son corps réside dans le château de corail.</div>
				</div>
				<div className="Marker" />
			</div>
			<div className="Event">
				<div className="EventInner">
					<div className="EventPeriod">Jour 57</div>
					<div className="EventDescription">Le génocide des elfes natifs.</div>
				</div>	
				<div className="Marker" />
			</div>
			<div className="Event">
				<div className="EventInner">
					<div className="EventPeriod">Jour 58</div>
					<div className="EventDescription">Découverte de la cité des Milles Morts.</div>
				</div>
				<div className="Marker" />
			</div>
			<div className="Event">
				<div className="EventInner">
					<div className="EventPeriod">Jour 60</div>
					<div className="EventDescription">Arrivée de la Pur-Sang, elle a des indices qui mènent à la découverte d'un temple Naga au centre de l'île.</div>
				</div>	
				<div className="Marker" />
			</div>
			<div className="Event">
				<div className="EventInner">
					<div className="EventPeriod">Jour 61</div>
					<div className="EventDescription">Expédition de sauvetage: retrouver le corps d'Elvis. Statut: Echoué.</div>
				</div>
				<div className="Marker" />				
			</div>
			<div className="Event">
				<div className="EventInner">
					<div className="EventPeriod">Jour 62</div>
					<div className="EventDescription NewMoon"><FontAwesomeIcon icon="circle"/> Nouvelle Lune. <br/>Apparition du vendeur d'âme.</div>
				</div>
				<div className="Marker" />
			</div>
			<div className="Event">
				<div className="EventInner">
					<div className="EventPeriod">Jour 63</div>
					<div className="EventDescription">Cambriolage chez Yolanda, embargo marchande contre les habitants de Port l'Espérance.</div>
				</div>
				<div className="Marker" />
			</div>
			<div className="Event">
				<div className="EventInner">
					<div className="EventPeriod">Jour 66</div>
					<div className="EventDescription">Découverte de la salle aux horloges dans les Voûtes.</div>
				</div>
				<div className="Marker" />
			</div>
			<div className="Event">
				<div className="EventInner">
					<div className="EventPeriod">Jour 69</div>
					<div className="EventDescription">Défaite du roi Sahuagin.</div>
				</div>
				<div className="Marker" />
			</div>
			<div className="Event">
				<div className="EventInner">
					<div className="EventPeriod">Jour 71</div>
					<div className="EventDescription">Arrivée des ouvriers. Début de l'expansion de Port l'Espérance.</div>
				</div>
				<div className="Marker" />
			</div>
			<div className="Event">
				<div className="EventInner">
					<div className="EventPeriod">Jour 73</div>
					<div className="EventDescription">Défaite de Nepthys.</div>
				</div>
				<div className="Marker" />
			</div>
			<div className="Event">
				<div className="EventInner">
					<div className="EventPeriod">Jour 75</div>
					<div className="EventDescription">Découverte du monde parallèle.</div>
				</div>
				<div className="Marker" />
			</div>
			<div className="Event">
				<div className="EventInner">
					<div className="EventPeriod">Jour 76</div>
					<div className="EventDescription FullMoon"><FontAwesomeIcon icon="circle"/> Pleine Lune<br/> Libération des anges sous la fontaine hurlante.</div>
				</div>
				<div className="Marker" />
			</div>
			<div className="Event">
				<div className="EventInner">
					<div className="EventPeriod">Jour 77</div>
					<div className="EventDescription">Défaite du géant de corail.</div>
				</div>
				<div className="Marker" />
			</div>
			<div className="MiddleLine" />
		</div>
		);
	}
}

export default Timeline;



// WEBPACK FOOTER //
// ./src/components/Timeline.js